import { combineReducers, configureStore } from "@reduxjs/toolkit";
import confirmReducer from "../reducer/confirmSlice";
import alertReducer from "../reducer/alertSlice";
import authReducer from "../reducer/authSlice";
import popupReducer from "./popupSlice";
import toastReducer from "./toastSlice";
import categoryReducer from "./categorySlice";
import loaderReducer from "./loaderSlice";

// alert, confirm 등 팝업은 데이터를 저장하기 위함보다는 호출에 편리한 구조를 위해 store를 사용
const reducers = combineReducers({
    auth: authReducer,
    confirm: confirmReducer,
    alert: alertReducer,
    popup: popupReducer,
    toast: toastReducer,
    category: categoryReducer,
    loader: loaderReducer,
});

export const store = configureStore({
    reducer: reducers,
    // 직렬화 불가한 값들을 사용할 때 추가 (function, Promise, Symbol, 다른 non-plain-JS-data값)
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});
export default store;
